const basico5 = {
    titulo: `JavaScript: estructuras condicionales simples y compuestas`,
    problemas: [
      {
        codigo: 1,
        descripcion: `No todos los problemas pueden resolverse empleando estructuras secuenciales. Cuando hay que tomar una decisión aparecen las estructuras condicionales.
En nuestra vida diaria se nos presentan situaciones donde debemos decidir.
¿Elijo la carrera A o la carrera B?
¿Me pongo este pantalón?
Para ir al trabajo, ¿Elijo el camino A o el camino B?
Al cursar una carrera, ¿Elijo el turno mañana, tarde o noche?
Es común que en un problema se combinan estructuras secuenciales y condicionales.
Las estructuras condicionales simples si la condición se verifica verdadera, se ejecutan las intrucciones.
En el lenguaje JavaScript la estructura condicional más importante se denomina if. Tiene la siguiente sintaxis:
<pre>
if (condición) {
    // código a ejecutar si la condición es verdadera
}
</pre>
Si la condición se verifica como verdadera, se ejecuta el código que se encuentra entre llaves.
La condición normalmente compara dos variables o valores mediante alguno de los siguientes operadores relacionales:
<pre>
== igual a
!= distinto de
> mayor que
< menor que
>= mayor o igual que
<= menor o igual que
=== igual y del mismo tipo
!== distinto y del mismo tipo
</pre>
Veamos un ejemplo donde la condición se verifica verdadera:
Se sabe que el sueldo de una persona 5000, luego si supera los 3000 dolares mostrar un mensaje en pantalla indicando que debe abonar impuestos`,
        programa: `let sueldo = 5000
if (sueldo > 3000) {
  console.log('Debe abornar impuestos')
}`,
        solucion: "'Debe abornar impuestos'",
      },{
        codigo: 2,
        descripcion: `Como vemos en el ejemplo anterior, la condición se verifica como verdadera si el valor de la variable sueldo es mayor a 3000, como le asignamos el valor 5000 luego la condición se verifica verdadera, sino se genera un error sintáctico. La condición debe encerrarse entre paréntesis obligatoriamente.
Si bien asignamos a la variable sueldo el valor 5000, dicho numero se podrá cargar por teclado, leer de un archivo, acceder de una base de datos etc.`,
        programa: `let clave = 'abc123'
if clave == 'abc123' {
  console.log('Clave correcta')
}`,
        solucion: "error",
      },{
        codigo: 3,
        descripcion: ``,
        programa: `let clave = 'abc123'
if (clave == 'abc123') {
  console.log('Clave correcta')
}`,
        solucion: "'Clave correcta'",
      },{
        codigo: 4,
        descripcion: `Se tienen 3 notas de un alumno. Calcular el promedio. Mostrar un mensaje por pantalla que diga "Promocionado" en caso que el promedio sea mayor o igual a 7:`,
        programa: `let nota1 = 9
let nota2 = 8
let nota3 = 10
let promedio = (nota1 + nota2 + nota3) / 3
if (promedio >= 7) {
  console.log('Promocionado')
}`,
        solucion: "'Promocionado'",
      },{
        codigo: 5,
        descripcion: `La estructura condicional compuesta es una estructura que se compone de una condición y dos estructuras secuenciales, una que se ejecuta si la condición es verdadera y otra que se ejecuta si la condición es falsa:
<pre>
if (condición) {
    // código a ejecutar si la condición es verdadera
} else {
    // código a ejecutar si la condición es falsa
}        
</pre>`,
        programa: `let sueldo = 950
if (sueldo > 3000) {
  console.log('Debe abornar impuestos')
} else {
  console.log('No debe abonar impuestos')
}`,
        solucion: "'No debe abonar impuestos'",	
      },{
        codigo: 6,
        descripcion: `Definir dos variables enteras con valores enteros cargados por asignación, disponer una estructura condicional compuesta que permita determinar y muestre cual de las dos variables es mayor.`,
        programa: `let valor1 = 10
let valor2 = 20
if (valor1 > valor2) {
  console.log(valor1)
} else {
  console.log(valor2)
}`,
        solucion: "20",	
      },{
        codigo: 7,
        descripcion: `Definir una variable que almacene el número de día del mes. Mostrar luego un mensaje si la variable tiene 1 o 2 digitos.`,
        programa: `let dia = 5
if (dia < 10) {
    console.log('1 digito')
} else {
    console.log('2 digitos')
}`,
        solucion: "'1 digito'",	
      },{
        codigo: 8,
        descripcion: `Se tiene en una variable la edad de una persona. Mostrar un mensaje si es mayor o menor de edad.`,
        programa: `let edad = 55
if (edad >= 18) {
  console.log('Es mayor de edad')
} else {
  console.log('Es menor de edad')
}`,
        solucion: "'Es mayor de edad'",	
      },{
        codigo: 9,
        descripcion: `Definir dos variables con valores enteros. Efectuar y mostrar la división del primero respecto al segundo. Mostrar un mensaje que no se puede efectuar la división en caso que el segundo valor sea igual a cero.`,
        programa: `let valor1 = 10
let valor2 = 5
if (valor2 == 0) {
  console.log('No se puede dividir')
} else {
    let division = valor1 / valor2
    console.log(division)
}`,
        solucion: "2",	
      },{
        codigo: 10,
        descripcion: `Se tiene el precio de un producto en una variable, si tiene un valor mayor o igual a 250 aplicarle un descuento del 10% en caso de tener un valor menor aplicar solo un descuento del 5%. Mostrar cuanto debe pagar el cliente con el descuento efectuado.`,
        programa: `let precio = 700
if (precio >= 250) {
  let descuento = precio * 0.10
  let precioFinal = precio - descuento
  console.log(precioFinal)
} else {
  let descuento = precio * 0.05
  let precioFinal = precio - descuento
  console.log(precioFinal)
}`,
        solucion: "630",	
      },{
        codigo: 11,
        descripcion: `La diferencia entre los operadores relacionales == y ===, es que el primero no tiene en cuenta el tipo de variable (numerica, string, etc) y el segundo tiene en cuenta el tipo de variable.
Con el operador == se compara el valor de las variables, con el operador === se compara el valor y el tipo de variable.
<pre>
let valor1 = '10'
let valor2 = 10
if (valor1 == valor2) {
  console.log('iguales')
} else {
  console.log('no iguales')
}
</pre>
En el ejemplo anterior los valores son iguales, ya que no tiene en cuenta el tipo de variable, la condición se verifica verdadera.
`,
        programa: `let valor1 = '10'
let valor2 = 10
if (valor1 == valor2) {
  console.log('iguales')
} else {
  console.log('no iguales')
}`,
        solucion: "'iguales'",	
      },{
        codigo: 12,
        descripcion: `En muchas situaciones esta característica de JavaScript puede ser contraproducente y presentarnos errores de lógica difíciles de identificar. Por ello se recomienda usar el operador === en lugar del operador ==.
<pre>
let valor1 = '10'
let valor2 = 10
if (valor1 === valor2) {
  console.log('iguales')
} else {
  console.log('no iguales')
}
</pre>
En el ejemplo anterior los valores son iguales pero el tipo de variables es distinto, luego la condición se verifica falsa.`,
        programa: `let valor1 = '10'
let valor2 = 10
if (valor1 === valor2) {
  console.log('iguales')
} else {
  console.log('no iguales')
}`,
        solucion: "'no iguales'",	
      },{
        codigo: 13,
        descripcion: `La misma causa se presenta con los operadores != y !==. El operador != compara el valor de las variables, el operador !== compara el valor y el tipo de variable.`,
        programa: `let altura1 = 190
let altura2 = '190'
if (altura1 !== altura2) {
  console.log('distintos')
} else {
  console.log('iguales')
}`,
        solucion: "'distintos'",	
      }
    ]
  }
  
  export default basico5;